import { OnboardingStep } from '../../../../services/exports/Constants';

export default {
  [OnboardingStep.EmailVerification]: 'Confirmar Endereço de E-mail',
  [OnboardingStep.StoreDetails]: 'Detalhes da loja',
  [OnboardingStep.BusinessInfo]: 'Detalhes da empresa',
  // Outside Germany, where Store details and Business details are still one step.
  store_and_business_info: 'Adicione os dados da sua loja',
  [OnboardingStep.PersonalInfo]: 'Adicione as suas informações pessoais',
  // In Germany: the person who signs the contract, for a GmbH its managing director (Nishita).
  owner_personal_info: 'Informações pessoais do proprietário',
  owner_personal_info_gmbh: 'Informações pessoais do proprietário / gerente',
  [OnboardingStep.ShippingInfo]: 'Adicione as suas informações de entrega',
  [OnboardingStep.BankInfo]: 'Adicione dados bancários para pagamentos',
  [OnboardingStep.TaxInfo]: 'A sua empresa está registada para IVA?',
  [OnboardingStep.BusinessDocs]: 'Documento comprovativo de empresa',
  [OnboardingStep.PersonalDocs]: 'Documento comprovativo de identidade',
  [OnboardingStep.InfoSubmission]: 'Receber pagamentos',
  confirm_info_gateway: 'Receber pagamentos – {{paymentGateway}}',
  [OnboardingStep.PaymentInfo]: 'Informações de pagamento',
  [OnboardingStep.Subscription]: 'Subscrição',
  [OnboardingStep.MobileApp]: 'Aplicação móvel',
  [OnboardingStep.DeliveryStructure]: 'Estrutura de entrega',
  [OnboardingStep.Contract]: 'Contrato',
  [OnboardingStep.ContractPayment]: 'Pagamento do contrato',
  [OnboardingStep.Documents]: 'Carregar documentos',
  [OnboardingStep.PromoCode]: 'Código promocional',
};
